import { useEffect, useRef, useState } from "react";
import { Button } from "../../../components/Button";
import addCircleImage from "./../../../assets/_AddCircleIcon_.svg";
import MuiButton from "@mui/material/Button";
import { IGroupItem } from "../../../@types/group.type";
import { getAllGroups } from "../../../services/api/groups/groupsService";
import vectorIcon from "../../../assets/_VectorIcon_.svg";
import React from "react";
import usePermission from "../../../hooks/usePermission";
import { FeatureStatic } from "../../../@types/statics/feature.static";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";

import { AgGridReact } from "ag-grid-react";
import { ColDef, FilterChangedEvent } from "ag-grid-community";
import secureLocalStorage from "react-secure-storage";
import { themeGrid } from "../../../themeGrid";
import { localeText } from "../../../localeTextFromGrid";
import { IApiResponse } from "../../../@types/api-response.type";

export const Permissions: React.FC = () => {
  const [groups, setGroups] = useState<IGroupItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const gridRef = useRef<AgGridReact<any>>(null);
  const [totalRows, setTotalRows] = useState(0);

  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.permissions.id);

  const columns: ColDef[] = [
    {
      field: "name",
      headerName: "Grupo",
      flex: 1,
      minWidth: 400,
    },
    {
      field: "createdByUserName",
      headerName: "Criado por",
      flex: 1,
      minWidth: 300,
    },
  ];
  
    const getFromCache = (key: string) => {
      const data = secureLocalStorage.getItem(key);
      return data ? JSON.parse(data as string) : null;
    };
  
    const [cachedFilters, setCachedFilters] = useState(
      getFromCache("agGridFiltersPermissions")
    );

    const [cachedSort, setCachedSort] = useState(
      getFromCache("agGridSortPermissions")
    );
  
    const saveToCache = (key: string, data: any) => {
      secureLocalStorage.setItem(key, JSON.stringify(data));
    };
    
    const onFilterChanged = (params: FilterChangedEvent) => {
      const filters = params.api.getFilterModel(); // Obtém o modelo de filtro
      saveToCache("agGridFiltersPermissions", filters); // Salva no cache
    };
    
    const onSortChanged = () => {
      const colState = gridRef.current!.api.getColumnState();
      const sortState = colState
        .filter(function (s) {
          return s.sort != null;
        })
        .map(function (s) {
          return { colId: s.colId, sort: s.sort, sortIndex: s.sortIndex };
        });
   
      saveToCache("agGridSortPermissions", sortState);
    };
    
      
      
  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }
    if (!gridRef.current) return;

    const gridApi = gridRef.current.api;

    if (gridApi) {
      // Restaurar filtros
      if (cachedFilters) {
        gridApi.setFilterModel(cachedFilters);
      }
      if (cachedSort) {
        gridApi.applyColumnState({
          state: cachedSort,
          defaultState: { sort: null },
        });
      }
    }
  }, [cachedFilters, cachedSort, columns]);

  useEffect(() => {
    async function fetchAllGroups() {
      try {
        setLoading(true);

        const response = await (getAllGroups()) as IApiResponse<IGroupItem[]>;

        setGroups(response.result);
        setTotalRows(response.result.length);

      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllGroups()
  }, []);

  function navigateToUpdatePage(id: string) {
    navigate(`update/${id}`);
  }

  return (
    <div className={styles.groups}>
      <div className={styles.back}>
        <MuiButton
          className={styles.buttonMui}
          onClick={() => navigate("/configurations")}
        >
          {vectorIcon && <img src={vectorIcon} />}
          Voltar a tela anterior
        </MuiButton>
      </div>
      <div className={styles.titleAndBtnCreate}>
        <h1>Grupos</h1>
        <Button
          iconUrl={addCircleImage}
          onClick={() => {
            navigate("/configurations/permissions/create");
          }}
          content="Novo Grupo"
          className={styles.button}
        />
      </div>

      <div className={styles.grid}>
      <AgGridReact
          ref={gridRef}
          rowData={groups}
          columnDefs={columns}
          theme={themeGrid}
          localeText={localeText}
          overlayNoRowsTemplate="<span style='color: gray;'>Sem registros encontrados</span>"
          defaultColDef={{
            sortable: true,
            editable: false,
            filter: true,
            floatingFilter: true,
          }}
          loading={loading}
          suppressCellFocus={true}
          rowStyle={{ cursor: "pointer" }}
          onRowClicked={(row) => navigateToUpdatePage(row.data.id)}
          onFilterChanged={onFilterChanged}
          onSortChanged={onSortChanged}
          animateRows={true}
        />
      </div>
    </div>
  );
};
